import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { DialogTipoRechazoCuotaPagoAfiliado } from 'src/app/components/afiliacion/afiliacion-cuota-rechazar.component';
import { PrestamoAbonoService } from 'src/app/services/prestamo-abono/prestamo-abono.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';


export interface DialogData
{
  
    idPlanPago:any
    recarga: boolean;
    archivos: any
    monto: any
    rutUsuario: any
    nombreUsuario: any  
    rol:any
    cantidadCuotas:any
    id:any
    tipoPrestamo:any
    idTipoPrestamo:any
    montoCuota:any
    fechaPrimerPago:any
    deshabilitado:boolean
    deshabilitadoMonto:boolean
    presionaEditar:boolean
    mostrarBotones: boolean
    mostrarBotonGuardar: boolean
    mostrarEditar:any
    disponiblePago:any
    idCantidadCuota: any,
    mostrarAprobarButton:any
    totalMaximo:any
    idUsuario:any
    tipos:any
    cuotas:any
    planes:any
    numCuota:any
    fechaCuota:any
    fechaPago:any
    estado:any
    nombreMotivoRechazo:any
    motivoRechazo:any 
    motivoAnulacion:any  
    tipoPostulacion:any
}

declare const Rut: any;
@Component({
  selector: 'app-validar-pago',
  templateUrl: '../../pages/afiliacion/cuota-validar/cuota-validar-pago.html',
  styleUrls: ['../../pages/afiliacion/cuota-validar/cuota-validar-pago.css']
})
export class DialogValidarPagoAfiliado implements OnInit
{
  
    prestamos:any
    planes: any
    user: any
    rol: string = localStorage.getItem("rol")
    config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
    configPlan: any = { itemsPerPage: 10, currentPage: 1, totalItems: 10, indexInicial: 0, indexMaximo: 10 }
    tipoPostulacion : string = "Disponibles"
    allComplete: boolean = false
    prestamoSolicitado: any
    idEjecutivo = localStorage.getItem("idUsuario")
    nombreUsuario: any
    rutUsuario:any
    totalMaximo: any
    router : any
    cantidadArchivos = 1
    deshabilitado: true
    deshabilitadoMonto: true
    mostrarBotones: false
    mostrarBotonGuardar: false
    afiliado: any = {rutAfiliado:'',idAfiliado: '',nombreAfiliado:'', apellidoAfiliado:''};
    isProcessing: boolean = false;
    formularioGuardado: boolean = true;
    afiliadoCuota: any = {
      monto: this.data.monto,
      id: this.data.id,
      cantidadCuotas:this.data.numCuota,
      idUsuario: localStorage.getItem("idUsuario"),
      idPlanPago: this.data.idPlanPago,
      idAfiliado:this.data.idUsuario,
      tipoPrestamo:this.data.tipoPrestamo,
      archivo: [], archivoTest: null,
      planes:[]}
    
 constructor( public dialogRef: MatDialogRef<DialogValidarPagoAfiliado>,
   public afiliacionService:AfiliacionService,
   public prestamoAbonoService:PrestamoAbonoService, 
   @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog ){
 }
 
  
    ngOnInit(): void
    { this.loadData() }
   
    loadData()
    {
      this.data.deshabilitado = true
      this.data.deshabilitadoMonto = true
      const estadosValidos = new Set(['EN VALIDACION']);
     
      if (this.rol=='ROLE_ADMINISTRADOR' || this.rol=='ROLE_ENCARGADO_CONTABILIDAD'){
        this.data.mostrarBotones = true
      }else if((this.rol=='ROLE_CONTABILIDAD' || this.rol=='ROLE_ENCARGADO_REGIONAL_CONTABLE')  && estadosValidos.has(this.data.estado)){
        this.data.mostrarBotones = true
      }else{
        this.data.mostrarBotones = false 
      }
    
      const estadosValidosBotonGuardar = new Set(['EN VALIDACION']);
      if ((this.rol=='ROLE_ADMINISTRADOR' || this.rol=='ROLE_ENCARGADO_CONTABILIDAD') && estadosValidosBotonGuardar.has(this.data.estado)){
        this.data.mostrarBotonGuardar = true
      }else if((this.rol=='ROLE_CONTABILIDAD' || this.rol=='ROLE_ENCARGADO_REGIONAL_CONTABLE') && estadosValidosBotonGuardar.has(this.data.estado)){
        this.data.mostrarBotonGuardar = true
      }else{
        this.data.mostrarBotonGuardar = false 
      }
  
      
    }
   
    pageChanged(event: any) {  this.config.currentPage = event 
        
      this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
      this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )
     }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir() { this.router.navigate(['/index']) }
  
    seleccionaArchivo(event: any, numero: number)
    {
      if(event.target.files.length > 0)
      {
      
          let vm = this
          let reader = new FileReader()
          this.afiliadoCuota.archivo[0] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size:event.target.files[0].size }
          reader.readAsDataURL(event.target.files[0])

          reader.onload = function() {
              vm.afiliadoCuota.archivo[0] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size:event.target.files[0].size }
          }
      }
  }
 
   
    onCancelarClick() {  
      this.data.recarga = false
        this.dialogRef.close()
    }
   

    onRechazarPagoClick(usuarioId: any){
      let vm = this
     
      let dataRechazo: any =
      {
          id: this.afiliadoCuota.id,
          idAfiliado: usuarioId,
          tiposRechazo: [],
          tipoRechazo: '',
          email: '',
          nombreCompleto: '',
          nombreProducto: 'PRESTAMO'
      }

      this.prestamoAbonoService.motivoRechazo(4).then
      (
          rechazos => { dataRechazo.tiposRechazo = rechazos
              
            }
      )
      .catch ( error => {console.log(error)
    } )
  
      const dialogRechazo = this.dialog.open(DialogTipoRechazoCuotaPagoAfiliado, { width: '50%', 
          data: dataRechazo });

      dialogRechazo.afterClosed().subscribe( () =>
      {
        this.dialogRef.close();
      })

  }  


  onAprobarPagoClick(id: any) {
    if (!this.formularioGuardado) {
        this.openAlertDialog('Debe guardar el formulario antes de aprobar el pago.', 'btn-warning');
        return;
    }
    
    if (this.isProcessing) {
        return; // Si ya está en proceso, no hacer nada
    }
    this.isProcessing = true; // Bloquear nuevas ejecuciones
    this.data.recarga = true;

    if (this.data.fechaPago.trim() == '') {
        this.openAlertDialog('Debe ingresar una fecha de pago.', 'btn-dark');
        this.isProcessing = false; // Liberar si hay error
        return;
    }

    const dialogRef = this.dialog.open(ConfirmationDialog, {
        data: { message: '¿Está seguro de aprobar la cuota de Pago?', buttonText: { ok: 'Sí', cancel: 'No' } }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
            Swal.fire({
                allowOutsideClick: false,
                icon: 'info',
                text: 'Cargando...'
            });
            Swal.showLoading();

            let fechaPago = this.data.fechaPago.split('-').reverse().join('-'); // Reversa de formato

            this.afiliacionService.aprobarPago(id, this.idEjecutivo, fechaPago).then(() => {
                this.openAlertDialog('La solicitud de pago fue aprobada exitosamente.', 'btn-success');
                Swal.close();
                this.dialogRef.close();
            }).catch(error => {
                console.log(error);
                this.openAlertDialog('Ha ocurrido un error al aprobar el pago.', 'btn-danger');
                Swal.close();
            }).finally(() => {
                this.isProcessing = false; // Liberar después del proceso
            });
        } else {
            this.isProcessing = false; // Si cancela, liberar
        }
    });
}

onGuardarClick(id: any){

    let vm = this;
    this.data.recarga=true   
    vm.data.recarga = true  
    if (vm.data.fechaPago.trim() =='') {
      this.openAlertDialog('Debe ingresar una fecha de pago.', 'btn-dark')
      return false
    }

    const dialogRef = this.dialog.open(ConfirmationDialog,
      {
          data: { message: '¿Esta seguro de modificar la cuota de Pago?', buttonText: { ok: 'Si', cancel: 'No' } }
      })
    dialogRef.afterClosed().subscribe((confirmed: boolean) =>
    {      
      if (confirmed)
      {
        this.formularioGuardado = true;
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        let fechaPago = vm.data.fechaPago.split('-')[2] + '-' + 
        vm.data.fechaPago.split('-')[1] + '-' + vm.data.fechaPago.split('-')[0]
 
        this.afiliacionService.editarPago(id,vm.idEjecutivo, vm.data,fechaPago).then(
          ()=>
          {
            this.openAlertDialog('La solicitud de pago fue modificada exitosamente.', 'btn-success')
            Swal.close();  
           this.permisosBotonera()

            return false;
          }
          ) .catch ( error =>
          {
              console.log(error)
              Swal.close();
              this.permisosBotonera()

              this.openAlertDialog('Ha ocurrido un error al modificada el pago.', 'btn-danger')
              return false;
          } )
      }
   
    })

}

permisosBotonera(){

  this.data.deshabilitado = false
  this.data.deshabilitadoMonto = true            
  this.data.mostrarEditar = true

  const estadosValidos = new Set(['EN VALIDACION']);
  if (this.rol=='ROLE_ADMINISTRADOR' || this.rol=='ROLE_ENCARGADO_CONTABILIDAD'){
    this.data.mostrarBotones = true
  }else if(this.rol=='ROLE_CONTABILIDAD' && estadosValidos.has(this.data.estado)){
    this.data.mostrarBotones = true
  }else{
    this.data.mostrarBotones = false 
  }

}

onDescargarArchivosClick(id: any)
  {   
      let vm = this
   
      vm.afiliacionService.traeArchivos(id).then
      (
          (archivos: any) =>
          {                
              archivos.forEach( archivo => {
                  var fileURL=`${environment.urlBlob}/${archivo.ubicacion}`
                  window.open(fileURL,'_blank')                     
              })  
             
          }
      )
      .catch
      (
          error =>
          {
              console.log(error)
              vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
          }
      )
  }



  onEditarPagoClick(id: any): void
    {
        this.formularioGuardado = false;
        this.data.deshabilitado = false
        this.data.deshabilitadoMonto = false        
        this.data.mostrarEditar = false
     
    }

   

}
